
import { z } from 'zod';
import { secureValidationSchemas } from '@/utils/security/validation';

export const updateCandidateContactInfoSchema = z.object({
  email: secureValidationSchemas.email.optional().or(z.literal('')),
  phone: secureValidationSchemas.phone.or(z.literal('')),
  linkedin_url: secureValidationSchemas.url.or(z.literal('')),
});

export type UpdateCandidateContactInfoSchema = z.infer<typeof updateCandidateContactInfoSchema>;
